/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_Json_FileInputs */

const en_download_json_file = /** @type {(inputs: Download_Json_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download JSON file`)
};

const nl_download_json_file = /** @type {(inputs: Download_Json_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download JSON-bestand`)
};

/**
* | output |
* | --- |
* | "Download JSON file" |
*
* @param {Download_Json_FileInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const download_json_file = /** @type {((inputs?: Download_Json_FileInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_Json_FileInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_download_json_file(inputs)
	return en_download_json_file(inputs)
});